import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import {
  Box,
  Flex,
  Icon,
  Input,
  Spacer,
  useDisclosure,
} from "@chakra-ui/react";
import { Space, Spin, Switch, Table } from "antd";
import { get } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { RiDeleteBin6Line, RiEditLine, RiSearch2Line } from "react-icons/ri";
import { useRestaurantMaster } from "../../store/restaurant/reducer";
import RestaurantEditDrawer from "../drawer/RestaurantEditDrawer";
import SlotDetailsDrawer from "../drawer/SlotDetailsDrawer";
import HomeDeleteConfirmation from "../modals/HomeDeleteConfirmation";
import RestaurantDetailsModal from "../modals/RestaurantDetailsModal";
import RestaurantDeleteConfirmation from "../modals/RestaurantDeleteConfirmation";
import axios from "axios";
import { useDispatch } from "react-redux";
import { REQUEST_MASTER_RESTAURANT } from "../../store/restaurant/restaurantActionTypes";
import { Spinner } from "@chakra-ui/react"
interface Props {
  query: string;
}

const RestaurantTable: React.FC<Props> = ({ query }) => {
  const dispatch = useDispatch();
  const { masterRestaurant, busy } = useRestaurantMaster();
  const searchColumns = useMemo(() => ["name"], []);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  console.log(masterRestaurant, "masterRestaurant");

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState<any[]>([]);

  const search = (restaurant: Record<string, any>) => {
    return searchColumns.some((column) => {
      return (
        get(restaurant, column, "")
          .toString()
          .toLowerCase()
          .indexOf(searchQuery.toLowerCase()) > -1
      );
    });
  };

  const [targetevent, setTargetEvent] = useState<any>();
  const [data, setData] = useState<any[]>([]);
  const [loading, setloading] = useState(true);

  const {
    isOpen: isViewOpen,
    onOpen: onViewOpen,
    onClose: onViewClose,
  } = useDisclosure();

  const {
    isOpen: isDeleteOpen,
    onOpen: onDeleteOpen,
    onClose: onDeleteClose,
  } = useDisclosure();

  const {
    isOpen: isUpdateOpen,
    onOpen: onUpdateOpen,
    onClose: onUpdateClose,
  } = useDisclosure();

  const {
    isOpen: isSlotDrawerOpen,
    onOpen: onSlotDrawerOpen,
    onClose: onSlotDrawerClose,
  } = useDisclosure();

  const handleSlotClick = (record: any) => {
    setTargetEvent(record);
    onSlotDrawerOpen();
  };
  const handleView = (record: any) => {
    setTargetEvent(record);
    onViewOpen();
  };

  const updateEvent = (record: any) => {
    setTargetEvent(record);
    onOpen();
  };

  const handleDelete = (record: any) => {
    setTargetEvent(record);
    onDeleteOpen();
  };
  useEffect(() => {
    if (masterRestaurant) {
      setData(
        masterRestaurant
          .filter(search)
          .map((restaurant: any, index: number) => ({
            key: restaurant._id,
            index: index + 1,
            name: restaurant.name,
            address: `${restaurant.address.street}, ${restaurant.address.city}, ${restaurant.address.state}`,
            phoneNumber: restaurant.contact.phone,
            email: restaurant.contact.email,
            cuisineType: restaurant.cuisines.join(", "),
            image: restaurant.image?.url
              ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${restaurant.image?.url}`
              : "",
            createdDate: new Date().toLocaleDateString(),
            originalData: restaurant,
          }))
      );
    }
    setloading(false);
  }, [masterRestaurant]);

  useEffect(() => {
    if (masterRestaurant) {
      const transformedData = masterRestaurant.map(
        (restaurant: any, index: number) => ({
          key: restaurant._id,
          index: index + 1,
          name: restaurant.name,
          address: `${restaurant.address.street}, ${restaurant.address.city}, ${restaurant.address.state}`,
          phoneNumber: restaurant.contact.phone,
          email: restaurant.contact.email,
          cuisineType: restaurant.cuisines.join(", "),
          image: restaurant.image?.url
            ? `${process.env.REACT_APP_IMAGE_BASE_URL}/${restaurant.image?.url}`
            : "",
          createdDate: new Date().toLocaleDateString(),
          originalData: restaurant,
        })
      );

      const filtered = searchQuery
        ? transformedData.filter(search)
        : transformedData;

      setFilteredData(filtered);
    }
  }, [searchQuery, masterRestaurant]);

  const handleSearch = (value: string) => {
    setSearchQuery(value);
  };
  const ImageOverlap = ({ url }: { url: string }) => (
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: "50%",
        overflow: "hidden",
        // border: "2px solid white",
        // marginLeft: url.[0] === 0 ? 0 : "-20px",
        position: "relative",
        backgroundColor: "white",
      }}
    >
      <img
        src={`https://rabbitvpn.sgp1.digitaloceanspaces.com/${url}`}
        alt="Restaurant"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );
  const SingleImage = ({ image }: { image: string }) => (
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: "50%",
        overflow: "hidden",
        backgroundColor: "white",
      }}
    >
      <img
        src={image}
        alt="Banner"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  );

  const [activeLoadingId, setActiveLoadingId] = useState<string | null>(null);

  const handleActiveChange = async (checked: boolean, record: any) => {
    try {
      setActiveLoadingId(record.originalData._id);
      await axios.patch(
        `${process.env.REACT_APP_BASE_URL}/admin/restaurant/active-status/${record.originalData._id}`,
        { active: checked },
      );
      dispatch({
        type: REQUEST_MASTER_RESTAURANT, onSuccess: async (response: any) => {
          setActiveLoadingId(null);
        }
      });
    } catch (error) {
      console.error(error);
      setActiveLoadingId(null);
      // } finally {
      //   setActiveLoadingId(null);
    }
  };

  const columns = [
    {
      title: "Nos.",
      dataIndex: "index",
      width: 80,
      render: (_: any, __: any, index: number) => `#${index + 1}`,
    },
    {
      title: "Image",
      dataIndex: "image",
      width: 100,
      render: (image: string) => <SingleImage image={image} />,
    },
    {
      title: "Restaurant Name",
      dataIndex: "name",
      width: 200,
    },
    {
      title: "Address",
      dataIndex: "address",
      width: 200,
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      width: 150,
    },
    {
      title: "Email",
      dataIndex: "email",
      width: 200,
    },
    {
      title: "Cuisine Type",
      dataIndex: "cuisineType",
      width: 120,
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      width: 150,
    },
    {
      title: "Details",
      dataIndex: "details",
      width: 100,
      render: (_: any, record: any) => (
        <a
          href="#"
          style={{ color: "#ff4d4f" }}
          onClick={(e) => {
            e.preventDefault();
            setTargetEvent(record);
            onViewOpen();
          }}
        >
          View
        </a>
      ),
    },
    {
      title: "Action",
      key: "action",
      width: 150,
      render: (_: any, record: any) => (
        <Space size="middle">
          <RiEditLine
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
            onClick={() => updateEvent(record.originalData)}
          />
          <RiDeleteBin6Line
            style={{
              color: "#212121",
              cursor: "pointer",
              height: "20px",
              width: "20px",
            }}
            onClick={() => handleDelete(record.originalData)}
          />
        </Space>
      ),
    },
    {
      title: "Active",
      dataIndex: "active",
      width: 100,
      render: (_: any, record: any) => (
        <>
          {activeLoadingId === record.originalData._id ? (
            <Spinner size="md" />
          ) : (
            <Switch
              checked={record.originalData.active}
              onChange={(checked) => handleActiveChange(checked, record)}
            />
          )}
        </>
      ),
    },
  ];

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  return (
    <>
      <div
        style={{
          width: "96vw",
          maxWidth: "96vw",
          maxHeight: "86vh",
          height: "86vh",
          top: "8vh ",
          left: "4vw",
          overflowY: "auto",
          position: "relative",
          backgroundColor: "#EEEEEE",
          padding: "30px",
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Flex w="full" alignItems="center" justifyContent="space-between">
            <Box
              display="flex"
              alignItems="center"
              bg="#FFF"
              border="1px solid #b2b2b233"
              borderRadius="12px"
              w="498px"
              padding="8px"
            >
              <Box
                pl={2}
                display="flex"
                alignItems="center"
                color="#9E9E9E"
                fontSize="2xl"
              >
                <img
                  src="/icons/searchlogo.svg"
                  alt="searchlogo"
                  style={{ height: "24px", width: "24px" }}
                />
              </Box>

              <Input
                id="search"
                type="text"
                placeholder="Search or type a command"
                onChange={(e) => handleSearch(e.target.value)}
                fontSize="sm"
                border="none"
                outline="none"
                color="#757575"
                _focus={{
                  border: "none",
                  outline: "none",
                  boxShadow: "none",
                }}
                bg={"transparent"}
                style={{
                  outline: "none",
                  boxShadow: "none",
                }}
              />
            </Box>

            <Spacer />

            <Box
              background="#E24441"
              fontSize={"sm"}
              color="#fff"
              w="fit-content"
              textAlign="center"
              p={3}
              onClick={() => {
                onOpen();
                setTargetEvent(null);
              }}
              cursor="pointer"
              borderRadius="8px"
              _hover={{ background: "#E24441" }}
            >
              + Add Restaurant
            </Box>
          </Flex>

          <Spacer></Spacer>
          {loading ? (
            <Spin size="large" />
          ) : (
            <Table
              rowSelection={rowSelection}
              columns={columns}
              dataSource={filteredData}
              scroll={{ x: "max-content" }}
              size="middle"
              style={{
                backgroundColor: "white",
                borderRadius: 6,
              }}
              pagination={{
                position: ["bottomRight"],
                pageSize: 9,
              }}
              loading={busy && filteredData.length === 0 ? true : false}
            />
          )}
        </div>
      </div>

      {isOpen && (
        <RestaurantEditDrawer
          isOpen={isOpen}
          onClose={onClose}
          restaurantData={targetevent}
        />
      )}

      {isViewOpen && (
        <RestaurantDetailsModal
          isOpen={isViewOpen}
          onClose={onViewClose}
          restaurantData={targetevent}
        />
      )}
      {isSlotDrawerOpen && (
        <SlotDetailsDrawer
          isOpen={isSlotDrawerOpen}
          onClose={onSlotDrawerClose}
          restaurantData={targetevent}
        />
      )}
      {isDeleteOpen && targetevent && (
        <RestaurantDeleteConfirmation
          isOpen
          onClose={onDeleteClose}
          restaurantData={targetevent}
        />
      )}
    </>
  );
};

export default RestaurantTable;
